import { useEffect } from "react";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";
import { useGlobalState } from "context/GlobalStateContext";

export const Toaster = ({ index, message, type, onClose }) => {
  const { direction } = useGlobalState();
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(index);
    }, 3000); // 3s

    return () => clearTimeout(timer);
  }, [onClose]);

  if (!message && !type && !onClose) return null;

  const typeStyles = { success: "bg-green-500", error: "bg-[red]", warning: "bg-[yellow]" };

  const icons = {
    success: <CheckCircleIcon className="w-10 h-10 text-white" />,
    error: <ExclamationCircleIcon className="w-10 h-10 text-white" />,
    warning: <ExclamationTriangleIcon className="w-10 h-10 text-white" />,
  };

  const topPosition = (index + 1) * 4.5;

  return (
    <div
      className={`fixed ${direction === "rtl" ? "left-0 flex-row-reverse" : "right-0"} p-3 rounded shadow-lg text-white transition-opacity duration-300 flex gap-2 items-center z-50 ${typeStyles[type]}`}
      style={{ top: `${topPosition}rem` }}
    >
      {icons[type]}
      <span>{message}</span>
    </div>
  );
};
